import {fetchAndParse, FetchResult} from './Common';
interface DocumentExpressionOptions {
	expressionName: string;
}

export class DocumentExpressionClass {
	private static _instance: DocumentExpressionClass;
	static instance() {
		return (this._instance = this._instance || new DocumentExpressionClass());
	}
	private constructor() {}

	private _resultByUrl: Map<string, FetchResult> = new Map();
	url(options: DocumentExpressionOptions) {
		return `/editor/docs/description/expressions/methods/${options.expressionName.toLowerCase()}.md`;
	}

	async fetch(options: DocumentExpressionOptions): Promise<FetchResult | undefined> {
		const url = this.url(options);
		let result = this._resultByUrl.get(url);
		if (!result) {
			result = await fetchAndParse(url);
		}
		return result;
	}
}

export const DocumentExpression = DocumentExpressionClass.instance();
